var map = {
	"./facebook.png": "c344",
	"./logo-docplanner-turquoise-rgb.png": "48e2",
	"./logo-doctoralia-turquoise-rgb.png": "f507",
	"./logo-doktortakvimi-turquoise-rgb.png": "5d39",
	"./logo-miodottore-turquoise-rgb.png": "ac50",
	"./logo-znamylekar-turquoise-rgb.png": "4e44",
	"./logo-znanylekarz-turquoise-rgb.png": "5c00",
	"./telegram.png": "dc8b",
	"./twitter.png": "490e",
	"./whatsapp.png": "e0ed",
	"./youtube.png": "7017"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";